const AdminPageUsers = () => {
    return (
        <div>Admin</div>
    )
}

export default AdminPageUsers;